module.exports = __webpack_public_path__ + "media/images/teams/logo__14-ab533799e47a41c1cbfe21a407badb9b.svg";